import header from "./en/header";
import footer from "./en/footer";
import home from "./en/home";
import aboutJavad from "./en/aboutJavad";
import aboutFaranack from "./en/aboutFaranack";
import contactPage from "./en/contactPage";
import notFound from "./en/notFound";

export default {
  header,
  footer,
  home,
  aboutJavad,
  aboutFaranack,
  contactPage,
  notFound,
};
